import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { mq } from '../../../../../../common/src/utils/styledComponentsUtils';
import LargeButton from '../../../../../../common/src/components/LargeButton';

interface Props {
  isMobile?: boolean;
  handleSubmit: () => void;
  handleCancel: () => void;
  handleRemove?: () => void;
}

const ActionButtons: React.FC<React.PropsWithChildren<Props>> = ({
  isMobile,
  handleSubmit,
  handleCancel,
  handleRemove,
}) => {
  const { t } = useTranslation();

  return (
    <Wrapper data-test-id="ProdFac_ActionButtons">
      <LargeButton
        onClick={handleSubmit}
        data-test-id="ProdFac_ActionButtons_Save"
        fullwidth
      >
        {t('Save')}
      </LargeButton>
      <CancelButton
        onClick={handleCancel}
        data-test-id="ProdFac_ActionButtons_Cancel"
        fullwidth
      >
        {t('Cancel')}
      </CancelButton>
      {handleRemove && isMobile && (
        <RemoveButton
          onClick={handleRemove}
          data-test-id="ProdFac_ActionButtons_Remove"
        >
          {t('Remove')}
        </RemoveButton>
      )}
    </Wrapper>
  );
};

const RemoveButton = styled.button`
  border: none;
  background-color: transparent;
  color: #f74040;
  text-align: center;
  width: 100%;
  font-size: 1.8rem;
  font-weight: 500;
  margin-top: 0.8rem;
  height: 4.4rem;
`;

const CancelButton = styled(LargeButton)`
  background-color: #f74040;
  margin-top: 0.8rem;

  &:hover {
    background-color: #f76565;
  }
`;

const Wrapper = styled.div`
  width: 100%;
  padding: 0.8rem;
  > button {
    border-radius: 50px;
    max-height: 4.4rem;
  }

  ${mq.laptop} {
    margin-top: 1.6rem;
    padding-top: 0;

    > button {
      max-height: 3.6rem;
    }
  }
`;

export default ActionButtons;
